if(typeof BSS_B2B != 'undefined' && window.location.pathname === '/cart') {
  setTimeout(() => {
    BSS_B2B.cp.changeProductPrice(JSON.parse($("#bss-b2b-store-data").html()), false, false)
  }, 1000)
}
if (window.location.pathname === '/cart') {
  const enableBanner = true;
  if (enableBanner && typeof BSS_B2B === 'object') {
    let ShopData = JSON.parse($('#bss-b2b-store-data').html())
    let customer = ShopData.customer
    document.addEventListener('bss_b2b_doneCheckQb', function(evt) {
        if (BSS_B2B.qbRules && BSS_B2B.qbRules.length) {
            let ruleApplied = rule = null;
            BSS_B2B.qbRules.forEach((rule) => {
              if (rule.id === 91355) {
                ruleApplied = rule
              }
            })
            if (ShopData && ShopData.customer && ShopData.customer.tags && ShopData.customer.tags.includes("b2b") && ruleApplied && ruleApplied.rule_type === 1 &&  ruleApplied.amount_table[0].discount_type === 2) {
              let priceForm = BSS_B2B.formatMoney(ruleApplied.amount_table[0].amount_from)
              let discountQB = ruleApplied.amount_table[0].discount_value
            const inputString = $("[bss-b2b-cart-total-price]").text();
            const regex = /\$?(\d{1,3}(,\d{3})*(\.\d+)?)$/;
            const match = inputString.match(regex);
              let qbBanner;
            if (match) {
                const subtotal = parseFloat(match[1].replace(/,/g, ''));
                qbBanner = `<foxkit-cart-goal data-plugin="CartGoal" class="foxkit-cartgoal" data-goal="1499"
                style="width: 33%;--progress: 27.55503669112742%;">
                <h4 class="foxkit-cartgoal__title">You are $${(ruleApplied.amount_table[0].amount_from - subtotal).toFixed(2)} away from additional ${discountQB}% discount</h4>
                <div class="foxkit-cartgoal__inner" bis_skin_checked="1">
                    <div class="foxkit-cartgoal__bar" bis_skin_checked="1">
                        <span data-progress="0"></span>
                    </div>
                    <span class="foxkit-cartgoal__icon"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none"
                            viewBox="0 0 12 12">
                            <path fill="currentColor"
                                d="M5.56445.761719C5.69336.503906 5.90104.375 6.1875.375s.49414.128906.62305.386719L8.20703 3.59766l3.13677.47265c.2864.02865.4726.17904.5585.45117.086.27214.0287.50847-.1718.70899L9.45312 7.44336l.53711 3.13674c.04297.2721-.05013.487-.27929.6445-.22917.1719-.4655.1934-.70899.0645L6.1875 9.82812 3.37305 11.2891c-.24349.1432-.47982.1289-.70899-.043-.22916-.1719-.32226-.3939-.27929-.666l.53711-3.13674L.644531 5.23047C.44401 5.02995.386719 4.79362.472656 4.52148c.085938-.27213.272136-.42252.558594-.45117l3.13672-.47265L5.56445.761719z">
                            </path>
                        </svg></span>
                </div>
            </foxkit-cart-goal>`;
              setTimeout(() => {
                const elementCustoms = document.querySelectorAll(".foxkit-cartgoal__icon, .foxkit-cartgoal__bar span");
                const pos = Math.min(100, subtotal*100/ruleApplied.amount_table[0].amount_from)
                elementCustoms.forEach(element => {
                    element.style.setProperty("--progress", `${pos}%`);
                })
                
              }, 1000)
            } else {
                console.log("...");
            }
              if (BSS_B2B.cart.qbPricingList && BSS_B2B.cart.qbPricingList.size) {
                  qbBanner = `<foxkit-cart-goal data-plugin="CartGoal" class="foxkit-cartgoal" data-goal="1499"
                    style="width: 33%;--progress: 27.55503669112742%;">
                    <h4 class="foxkit-cartgoal__title">Congratulations! You have gained additional ${discountQB}% Discount!</h4>
                    <div class="foxkit-cartgoal__inner" bis_skin_checked="1">
                        <div class="foxkit-cartgoal__bar" bis_skin_checked="1">
                            <span data-progress="0"></span>
                        </div>
                        <span class="foxkit-cartgoal__icon"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none"
                                viewBox="0 0 12 12">
                                <path fill="currentColor"
                                    d="M5.56445.761719C5.69336.503906 5.90104.375 6.1875.375s.49414.128906.62305.386719L8.20703 3.59766l3.13677.47265c.2864.02865.4726.17904.5585.45117.086.27214.0287.50847-.1718.70899L9.45312 7.44336l.53711 3.13674c.04297.2721-.05013.487-.27929.6445-.22917.1719-.4655.1934-.70899.0645L6.1875 9.82812 3.37305 11.2891c-.24349.1432-.47982.1289-.70899-.043-.22916-.1719-.32226-.3939-.27929-.666l.53711-3.13674L.644531 5.23047C.44401 5.02995.386719 4.79362.472656 4.52148c.085938-.27213.272136-.42252.558594-.45117l3.13672-.47265L5.56445.761719z">
                                </path>
                            </svg></span>
                    </div>
                </foxkit-cart-goal>`;
              }
              // let bannerCartPage = $(".bss-custom-banner-cart")
              let bannerCartPage = document.getElementById("bird-total-fix");
              if (bannerCartPage) {
                if(!bannerCartPage.querySelector("foxkit-cart-goal")) {
                  bannerCartPage.insertAdjacentHTML("afterbegin", qbBanner)
                  bannerCartPage.style.justifyContent = "space-between"
                }
              }
            }
        }
    });
  }
}